module.exports = __webpack_public_path__ + "img/icon_police_01.42bc8b90.png";